/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutBillingStatusRequestBodyTypename = "PutBillingStatusRequestBody" as const;

/**
 *
 * @export
 * @interface PutBillingStatusRequestBody
 */
export interface PutBillingStatusRequestBody {
  /**
   *
   * @type {string}
   * @memberof PutBillingStatusRequestBody
   */
  status: PutBillingStatusRequestBodyStatusEnum;
  /**
   *
   * @type {string}
   * @memberof PutBillingStatusRequestBody
   */
  statusDatail?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutBillingStatusRequestBody
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PutBillingStatusRequestBodyStatusEnum {
  Canceled = "canceled",
}

export function PutBillingStatusRequestBodyFromJSON(json: any): PutBillingStatusRequestBody {
  return PutBillingStatusRequestBodyFromJSONTyped(json, false);
}

export function PutBillingStatusRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutBillingStatusRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutBillingStatusRequestBodyTypename,

    status: json["status"],
    statusDatail: !exists(json, "status_datail") ? undefined : json["status_datail"],
  };
}

export function PutBillingStatusRequestBodyToJSON(object?: PutBillingStatusRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    status: value.status,
    status_datail: value.statusDatail,
  };
}
